<template>
  <div class="schedule-wrapper">
    <div class="schedule-header" v-if="scheduleData.length > 0">
      <div class="page-title">
        <h2>预约管理</h2>
      </div>
      <!-- 导航 -->
      <div class="schedule-nav-wrapper" ref="scheduleNav" :class="{'fixed-nav': fixedNav}">
        <ul class="schedule-nav-list" ref="navList">
          <li class="nav-item" :class="{'active': currentSchedule == index}" @click="jumpSchedule(item, index)" v-for="(item, index) in scheduleData">
            <div class="date">{{item.day}}</div>
            <div class="weekday">{{item.week}}</div>
            <div class="people">{{item.enrollers}}/{{item.pat_limit}}人</div>
          </li>
        </ul>
      </div>
    </div>


    <div class="schedule-main" v-if="scheduleData.length > 0">
      <!-- 每日日程 -->
      <div class="day-schedule">
        <!-- 每日时间段 -->
        <div class="schedule-card" v-for="card in scheduleData[currentSchedule].schedule">
          <div class="card-header">
            <div class="schedule-date">{{scheduleData[currentSchedule].day}}<span>{{card.formatStartTime}} - {{card.formatEndTime}}</span></div>
            <div class="schedule-prople">{{card.enrollers}}/{{card.pat_limit}}<span>人</span></div>
          </div>
          <div class="card-content">
            <div class="reservation-list" v-if="card.pat_info && card.pat_info.length > 0">
              <router-link class="reservation-item" :to="{name: 'PatientRecord', params: {id: patient.pat_id}}" v-for="(patient, index) in card.pat_info" :key="index">
                <div class="patient-info">
                  <div class="name">{{patient.username}}</div>
                  <span class="info">{{patient.gender | genderFilter}} | {{patient.birthday | ageFilter}}</span>
                </div>
                <div class="link-arrow"><icon icon-class="arrow" /></div>
              </router-link>
            </div>
            <!-- 无数据 -->
            <div class="empty-item-schedule" v-else>
              <icon icon-class="empty-schedule" />
              <p>暂无患者预约</p>
            </div>
          </div>
          <div class="card-control">
            <button class="cancel-schedule-button" @click="cancelSchedule(card, scheduleData[currentSchedule].day)">取消此日程</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 空数据状态 -->
    <div class="empty-schedule" v-if="scheduleData.length == 0">
      <icon icon-class="empty-schedule" />
      <p>暂无诊疗日程</p>
    </div>
    <div class="fixed-control">
      <button class="add-schedule-button" @click="addSchedule">新增线上诊疗日程</button>
    </div>

    <!-- 弹窗 -->
    <!-- 取消日程 -->
    <x-dialog v-if="cancelDialogShow" title="取消诊疗日程" @close="cancelDialogShow = false">
      <div class="content-wrapper">
        <div class="content-text">
          <div class="time">{{willDelData.day}} {{willDelData.formatStartTime}} - {{willDelData.formatEndTime}}</div>
          <p>将取消此时间段的诊疗日程</p>
          <div class="warning">已预约患者的治疗进度可能会受到影响</div>
        </div>
        <div class="error-control">
          <button class="cancel" @click="cancelDialogShow = false">我再想想</button>
          <button class="confirm" @click="cancel" :disabled="canceling">确定</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .schedule-wrapper{
    position: relative;
    min-height: 100vh;
    background: #F7F7F7;

    .schedule-header{

      width: 100%;
      background: #F7F7F7;
      z-index: 10;
      h2{
        font-size: 18px;
      }
    }
    .schedule-nav-wrapper{
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 12px 0 16px;
      -webkit-overflow-scrolling: touch;
      background: #F7F7F7;
      .schedule-nav-list{
        padding: 0 16px;
        display: flex;
        float: left;
        .nav-item{
          width: 72px;
          height: 84px;
          display: flex;
          flex-shrink: 0;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #FFF;
          border-radius: 4px;
          margin-right: 12px;
          font-weight: bold;
          transition: all .2s;
          &:last-child{
            margin-right: 0;
          }
          &.active{
            background: @xile;
            .date, .weekday, .people{
              color: #FFF;
            }
            box-shadow: 0px 2px 8px 0px rgba(0,132,138,0.3);
            transform: scale(1.1);
          }
          .date{
            font-size: 16px;
            line-height: 16px;
            color: @black;
          }
          .weekday{
            margin-top: 8px;
            font-size: 14px;
            line-height: 14px;
            color: @black;
          }
          .people{
            margin-top: 9px;
            font-size: 14px;
            line-height: 14px;
            color: #999;
          }
        }
      }
    }
    .schedule-main{
      // margin-top: 16px;
      padding: 52px 16px 72px;
      .day-schedule{
        .schedule-card{
          background: #FFF;
          border-radius: 4px;
          overflow: hidden;
          box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
          margin-bottom: 12px;
          .empty-item-schedule{
            height: 111px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #CCC;
            svg{
              font-size: 40px;
            }
            p{
              margin-top: 8px;
              font-size: 15px;
              line-height: 15px;
            }
          }
          .card-header{
            width: 100%;
            height: 48px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            background: #FAFAFA;
            border-bottom: 1px solid #F3F3F3;
            .schedule-date{
              position: relative;
              padding-left: 16px;
              color: @black;
              font-size: 15px;
              line-height: 18px;
              span{
                margin-left: 8px;
              }
              &::after{
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                height: 16px;
                width: 4px;
                background: @xile;
                border-radius: 2px;
              }
            }
            .schedule-prople{
              font-size: 16px;
              line-height: 16px;
              color: @black;
              font-weight: bold;
              span{
                margin-left: 4px;
                font-size: 14px;
              }
            }
          }
          .card-content{
            .reservation-list{
              padding: 16px 0;
              .reservation-item{
                height: 36px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 16px 0 20px;
                margin-bottom: 6px;
                transition: all .1s;
                &:active{
                  background: #F9F9F9;
                }
                &:last-child{
                  margin-bottom: 0px;
                }
                .patient-info{
                  display: flex;
                  align-items: baseline;
                  .name{
                    font-size: 14px;
                    color: @black;
                  }
                  .info{
                    margin-left: 12px;
                    font-size: 14px;
                    color: #666;
                  }
                }
                .link-arrow{
                  svg{
                    font-size: 12px;
                    color: #999;
                  }
                }
              }
            }
          }
          .card-control{
            padding: 12px 16px 16px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            border-top: 1px solid #F3F3F3;
            .cancel-schedule-button{
              display: flex;
              justify-content: center;
              align-items: center;
              width: 110px;
              height: 32px;
              border: 1px solid #999;
              background: #FFF;
              color: #666;
              font-size: 14px;
              border-radius: 16px;
              transition: all .1s;
              &:active{
                opacity: .8;
              }
            }
          }
        }
      }
    }
    .fixed-control{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      background: #FFF;
      padding: 12px 16px;
      z-index: 10;
      .add-schedule-button{
        @button-base();
        width: 100%;
        height: 40px;
        font-size: 14px;
        box-shadow: 0px 2px 8px 0px rgba(0,132,138,0.3);
      }
    }
  }
  // 空状态
  .empty-schedule{
    position: absolute;
    top: 20px;
    left: 16px;
    right: 16px;
    bottom: 84px;
    background: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
    svg{
      font-size: 72px;
      color: #CCC;
    }
    p{
      margin-top: 12px;
      font-size: 15px;
      line-height: 15px;
      color: #CCC;
    }
  }
  // 弹窗样式
  .content-wrapper{
    padding: 40px 0 32px;
    text-align: center;
    .content-text{
      font-weight: bold;
      .time{
        font-size: 18px;
        line-height: 18px;
        color: @error;
        margin-bottom: 8px;
      }
      p{
        font-size: 16px;
        line-height: 16px;
        color: @black;
      }
      .warning{
        margin-top: 16px;
        font-size: 14px;
        line-height: 14px;
        color: #666;
        font-weight: normal;
      }
    }
    .error-control{
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        @button-base();
        height: 36px;
        font-size: 14px;
        width: 128px;
        &.cancel{
          background: #FFF;
          border: 1px solid #999;
          color: #999;
          margin-right: 15px;
        }
        &.confirm{}
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        fixedNav: false,
        scheduleData: [],
        navOffet: null,
        currentSchedule: 0,
        // 即将删除的id
        willDelId: null,
        cancelDialogShow: false,
        canceling: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      this.getData();
    },
    mounted() {},
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    components: {
      xDialog
    },
    methods: {
      getData() {
        this.$root.post('/getSchedule', {
          doc_id: this.userInfo.user_id
        }).then(data => {
          if(data.length > 0) {
            data.forEach(item => {
              if(item.schedule && item.schedule.length > 0) {
                item.schedule.forEach(stuff => {
                  stuff.formatStartTime = moment(stuff.start_time * 1000).format('HH:mm');
                  stuff.formatEndTime = moment(stuff.end_time * 1000).format('HH:mm');
                })
              }
            })
            // data[0].schedule[0].pat_info = [{username: '测试名字', gender: 1, birthday: '1991/08'}];
            console.log(data);
            this.scheduleData = data || [];
          }else {
            this.scheduleData = data || [];
          }
        })
      },
      handleNavAction() {
        let itemOffsetLeft = this.$refs.scheduleNav.scrollLeft;
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 固定顶部导航
        if(scrollTop >= this.navOffet) {
          this.fixedNav = true;
        }else {
          this.fixedNav = false;
        }
        this.scheduleData.forEach((item, index) => {
          // 非最后一个日程则高亮顶部导航
          if(this.currentSchedule < this.scheduleData.length) {
            if((scrollTop + 160) >= item.offset && (scrollTop + 160) < this.scheduleData[index + 1].offset) {
              this.currentSchedule = index;
              item.active = true;
            }else {
              item.active = false;
            }
          }else {
            this.scheduleData.forEach(stuff => {
              stuff.active = false;
            })
            item.active = true;
          }

        })
      },
      jumpSchedule(item, index) {
        this.currentSchedule = index;
        // if(index == 0) {
        //   $(window).scrollTop(40);
        // }else {
        //   // 点击导航跳转至对应日程
        //   $(window).scrollTop(item.offset + 120);
        // }
      },
      // 新增日程
      addSchedule() {
        this.$router.push('/doctor/edit-schedule');
      },
      // 取消日程
      cancelSchedule(card, day) {
        this.willDelData = card;
        this.willDelData.day = `${day.split('.')[0]}月${day.split('.')[1]}日`;
        this.cancelDialogShow = true;
      },
      cancel() {
        this.canceling = true;
        this.$root.post('/cancelSchedule', {
          schedule_id: this.willDelData.schedule_id
        }).then(data => {
          console.log(data);
          this.canceling = false;
          if(data.status == 1) {
            this.$notify({
              message: '诊疗日程取消成功',
              background: '#00848A',
            })
            this.cancelDialogShow = false;
            this.currentSchedule = this.currentSchedule == 0 ? 0 : this.currentSchedule - 1;
            this.getData();
          }else {
            this.$notify(data.msg);
          }
        })
        console.log('cancel');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Schedule/index.vue